module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAn0lEQVRIx2NgcN81MGjU4lGLaYbC2y4NCGL4TzTYdfYNhQqQAbEWH7/+QSh0//0X33ApAEoBFRy/9pHKFn//+ffn779//v6Di2RMupY55TqcC5QCKgAqo7LFQPDy/U9kbsmsW8WzbuJRQB2Lz935JBq2//7z73iCGqgAqIzKFr/99GvFgefIQY0GgFIrD74AKiPW4gHLTqNF5qjFw85iAFBBJDkxV0o0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/hn.png
// module id = 839
// module chunks = 0